import { AMBIENT_SOUNDS, AMBIENT_NONE } from '@/data/audio'

interface AmbientSelectorProps {
  currentSound: string
  onSelect: (soundId: string) => void
}

export function AmbientSelector({ currentSound, onSelect }: AmbientSelectorProps) {
  const options = [AMBIENT_NONE, ...AMBIENT_SOUNDS]

  return (
    <div className="space-y-2">
      <div className="text-xs font-black tracking-[0.25em] text-slate-400 mb-3">环境音效 AMBIENT</div>
      {options.map((sound) => (
        <button
          key={sound.id}
          onClick={() => onSelect(sound.id)}
          className={`w-full flex items-center gap-3 p-3 rounded-xl transition-all ${
            currentSound === sound.id
              ? 'bg-sky-500 text-white'
              : 'bg-slate-50 hover:bg-slate-100 text-slate-700'
          }`}
        >
          <span className="text-xl">{sound.icon}</span>
          <div className="text-left flex-1">
            <div className="text-sm font-semibold">{sound.name}</div>
            <div className={`text-xs ${currentSound === sound.id ? 'text-sky-100' : 'text-slate-400'}`}>
              {sound.description}
            </div>
          </div>
          {currentSound === sound.id && (
            <svg className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
          )}
        </button>
      ))}
    </div>
  )
}
